module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "conInner"
  }, [_c('div', {
    staticClass: "white_box"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "top"
  }), _vm._v(" "), _c('div', {
    staticClass: "body"
  }, [_c('div', {
    staticClass: "inner_con"
  }, [_c('div', {
    staticClass: "portrait"
  }, [_c('div', {
    staticClass: "userico"
  }, [(_vm.$store.getters.face && _vm.$store.getters.face.length > 0) ? _c('img', {
    attrs: {
      "height": "120",
      "width": "120",
      "src": _vm.$store.getters.face
    }
  }) : _c('img', {
    attrs: {
      "src": "//static.kxymall.com/images/default_face.jpg",
      "height": "120",
      "width": "120"
    }
  })]), _vm._v(" "), _c('router-link', {
    staticClass: "uploadIco",
    attrs: {
      "to": "/member/personalProfile"
    }
  }, [_vm._v("完善个人资料")])], 1), _vm._v(" "), _c('dl', {
    staticClass: "baseStat"
  }, [_c('dt', [_vm._v("您好，"), _c('strong', [_vm._v(_vm._s(_vm.$store.getters.name))]), _vm._v("，欢迎回来！")]), _vm._v(" "), _c('dd', [_c('span', [_vm._v("等级："), _c('em', [_vm._v(_vm._s(_vm.memberName))]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        path: '/help',
        query: {
          articleid: 13
        }
      },
      "target": "_blank"
    }
  }, [_vm._v("[如何升级]")])], 1), _vm._v(" "), _c('span', [_vm._v("等级积分："), _c('em', [_vm._v(_vm._s(_vm.stat.levelPoint))])])]), _vm._v(" "), _c('dd', [_c('span', {
    staticStyle: {
      "margin-right": "3px"
    }
  }, [_vm._v("首购积分："), _c('em', [_vm._v(_vm._s(_vm.stat.firstBuyPoint))])])])]), _vm._v(" "), _c('div', {
    staticClass: "myLinks"
  }, [_c('div', {
    staticClass: "cr_admonishtop"
  }), _vm._v(" "), _c('span', {
    staticClass: "mlTop"
  }), _vm._v(" "), _c('div', {
    staticClass: "mlInner"
  }, [_c('ul', {
    staticClass: "clearfix"
  }, [_c('li', {
    staticClass: "lnk1"
  }, [_c('router-link', {
    attrs: {
      "to": "/member/comments"
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.stat.commentCount) + "条")]), _vm._v("评论消息")])], 1), _vm._v(" "), _c('li', {
    staticClass: "lnk2"
  }, [_c('router-link', {
    attrs: {
      "to": "/member/order"
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.stat.orderCount) + "笔")]), _vm._v("订单信息")])], 1), _vm._v(" "), _c('li', {
    staticClass: "lnk3"
  }, [_c('a', [_c('em', [_vm._v(_vm._s(_vm.stat.consultCount) + "条")]), _vm._v("咨询回复")])]), _vm._v(" "), _c('li', {
    staticClass: "lnk4"
  }, [_c('router-link', {
    attrs: {
      "to": "/member/favorite?status=1"
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.stat.favoriteCount) + "个")]), _vm._v("收藏商品\n                  ")])], 1)])]), _vm._v(" "), _c('span', {
    staticClass: "mlBtm"
  }), _vm._v(" "), _c('div', {
    staticClass: "cr_admonishbottom"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "box myorder",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('div', {
    staticClass: "top order"
  }), _vm._v(" "), _c('div', {
    staticClass: "body"
  }, [_c('Table', {
    staticClass: "order-table",
    staticStyle: {
      "border-top": "none"
    },
    attrs: {
      "columns": _vm.column,
      "data": _vm.orderList,
      "no-data-text": "尚无订单"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "oper clearfix"
  }, [_c('router-link', {
    staticClass: "checkAll",
    attrs: {
      "to": "/member/order"
    }
  }, [_vm._v("查看所有"), _c('strong', [_vm._v(_vm._s(_vm.stat.orderCount))]), _vm._v("笔订单")])], 1), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  })]), _vm._v(" "), _c('Modal', {
    attrs: {
      "width": "530",
      "title": "请输入取消原因"
    },
    model: {
      value: (_vm.cancelModal),
      callback: function($$v) {
        _vm.cancelModal = $$v
      },
      expression: "cancelModal"
    }
  }, [_c('Input', {
    staticStyle: {
      "width": "480px"
    },
    attrs: {
      "type": "textarea",
      "rows": 4
    },
    model: {
      value: (_vm.reason),
      callback: function($$v) {
        _vm.reason = $$v
      },
      expression: "reason"
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "size": "large"
    },
    on: {
      "click": _vm.cancelOrder
    }
  }, [_vm._v("确认取消订单")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-75a89b43"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/member-center/right/member.vue
// module id = 1640
// module chunks = 1